import { AddModalComponent } from './add-modal/add-modal.component';
import { GeneralService } from './../../services/admin/general.service';
import { CrudFb60Service } from './../../services/crud-fb60/crud-fb60.service';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { User } from '../../models/user';
import { ENPOINT } from './../../services/endpoint';
import { GLOBAL } from './../../services/global';
import { NumberFormatStyle } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-crudfb60',
  templateUrl: './crud-fb60.component.html',
  styleUrls: ['./crud-fb60.component.scss'],
  providers: [GeneralService, CatalogsService, CrudFb60Service]
})
export class CrudFb60Component implements OnInit {
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  private basePath;
  public user: User;
  url: string;
  rows = [];
  editClicked = false;
  indexRow;
  claveProductos;
  descripcionProducto;
  modalMensaje;
  respuesta;
  closeResult: string;

  cuentasm$: Observable<any>;
  cuentasmLoading = false;
  cuentasminput$ = new Subject<string>();

  cecos$: Observable<any>;
  cecosLoading = false;
  cecosinput$ = new Subject<string>();

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private catalogos: CatalogsService,
    private storageService: StorageService,
    private crudFb60: CrudFb60Service,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.url = GLOBAL.url;
    this.basePath = ENPOINT.url;

    this.getCuentaDeMayor();
    this.getCecos();
  }

  ngOnInit() {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });
    this.noBack();
    this.modulo();
    this.productosSat();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Claves de productos SAT').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  getCuentaDeMayor() {
    this.cuentasm$ = concat(of([]),
      this.cuentasminput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.cuentasmLoading = true),
        switchMap(term =>
          this.catalogos.obtenerCuentaDeMayor(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.cuentasmLoading = false)
          ))
      )
    );
  }

  getCecos() {
    this.cecos$ = concat(of([]),
      this.cecosinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.cecosLoading = true),
        switchMap(term =>
          this.catalogos.obtenerCecos(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.cecosLoading = false)
          ))
      )
    );
  }

  productosSat() {
    this.crudFb60.obtenerProductos().subscribe(
      data => {
        const productos = data.claveProductoSAT;
        this.rows = productos;
      },
      err => {
        // console.log(err);
      },
    );
  }

  editarProducto(index) {
    this.editClicked = true;
    this.indexRow = index;
  }

  cancelar(index) {
    this.editClicked = false;
  }

  cambiarClave(row) {
    const clave = this.claveProductos;
    row.claveProductoSat = clave;
  }

  cambiarDescripcion(row) {
    const descripcion = this.descripcionProducto;
    row.descripcion = descripcion;
  }

  cambiarCuentaDeMayor(rows, row, e) {
    row.cuenta_de_mayor = e.cuentaDeMayor;
  }

  cambiarCentroCosto(row, e) {
    row.centroCosto = e.centroDeCoste;
  }

  guardarEdicion(row, mensaje) {
    this.editClicked = false;
    let crearProductos: any;

    crearProductos = {
      claveProductoSat: row.claveProductoSat,
      descripcion: row.descripcion,
      cuentaContable: row.cuentaContable,
      centroCosto: row.centroCosto
    };

    crearProductos = JSON.stringify(crearProductos);

    this.crudFb60.postCargaProductos(crearProductos).subscribe(
      data => {
        this.respuesta = data.result.message;
        this.rows = [];
        this.productosSat();
        this.openMensaje(mensaje);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );

  }

  openMensaje(mensaje) {
    this.modalMensaje = this.modalService.open(mensaje, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  eliminarProducto(row) {
    const clave = row.claveProductoSat;

    this.crudFb60.eliminarProducto(clave).subscribe(
      data => {
        const respuesta = data.result;
        if (respuesta.status === 'S') {
          this.toasterService.pop('success', '', respuesta.message);
        } else {
          this.toasterService.pop('error', '', respuesta.message);
        }
        this.rows = [];
        this.productosSat();
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  openAddModal(content) {

    const modalRef = this.modalService.open(AddModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 's') {
        this.rows = [];
        this.productosSat();
      }
      modalRef.close();
    }).catch((error) => {
      // console.log(error);
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/crud-fb60/crud-fb60.component.ts